import { Field, Form, Formik } from 'formik'
import React from 'react'
import { ROUTE } from 'shared-constants'
import styled from 'styled-components'
import * as Yup from 'yup'
import { Button, BUTTON_VARIANT } from 'components/Button'
import Icons from 'components/Icon'
import { Input } from 'components/Input'
import PasswordInput from 'components/PasswordInput'
import { Text } from 'components/Typography'
import { useGoogleAnalytics } from 'providers/googleAnalytics'
import { useUserAuth } from 'providers/userAuth'
import { USER_TYPE, PROVIDER_METHODS } from 'providers/userAuthUtil'
import { COLOR_INTENT, FONT_SIZE, SPACE } from 'Theme'

const validationSchema = Yup.object().shape({
  password: Yup.string().label('Password').required(),
  email: Yup.string().email('Invalid email').trim().label('Email').required(),
})

const SocialForm = styled('form')`
  width: 100%;
  margin-top: ${SPACE.PX_26};
`

const ClientSignIn = () => {
  const userAuth = useUserAuth()
  const { executeDataToDataLayer } = useGoogleAnalytics()
  return (
    <>
      <SocialForm>
        <Button
          onClick={() => {
            userAuth.thirdPartySignIn(PROVIDER_METHODS.GOOGLE)
          }}
          variant={BUTTON_VARIANT.OUTLINE}
          icon={Icons.Google}
        >
          Sign in with Google
        </Button>
        {/* TODO: uncomment after we'll handle FB social login

        <Button
          onClick={() => {
            userAuth.thirdPartySignIn(PROVIDER_METHODS.FACEBOOK)
          }}
          variant={BUTTON_VARIANT.OUTLINE}
          mt={SPACE.PX_15}
          icon={Icons.Facebook}
        >
          Sign in with Facebook
        </Button>
        */}
      </SocialForm>
      <Text
        as="p"
        color={COLOR_INTENT.SIGN_IN.TEXT}
        fontSize={FONT_SIZE.PX_12}
        m={`${SPACE.PX_20} 0`}
        textAlign="center"
      >
        or sign in using email
      </Text>
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={validationSchema}
        onSubmit={({ email, ...restValue }) =>
          userAuth.signIn({
            executeDataToDataLayer,
            userType: USER_TYPE.CLIENT,
            email: email.trim(),
            ...restValue,
          })
        }
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Field name="email">
              {({ field, meta }) => (
                <Input
                  label="Email"
                  isDisabled={userAuth.isLoading}
                  isError={meta.touched && meta.error !== undefined}
                  hint={meta.touched ? meta.error : ''}
                  hasHint
                  {...field}
                />
              )}
            </Field>
            <Field name="password">
              {({ field, meta }) => (
                <PasswordInput
                  isDisabled={userAuth.isLoading}
                  isError={meta.touched && meta.error !== undefined}
                  hint={meta.touched ? meta.error : ''}
                  hasHint
                  labelActionLink={{
                    label: 'Reset password',
                    href: ROUTE.RESET_PASSWORD(),
                  }}
                  {...field}
                />
              )}
            </Field>
            <Button
              isDisabled={userAuth.isLoading}
              isLoading={userAuth.isLoading}
              type="submit"
            >
              Sign in
            </Button>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default ClientSignIn
